<template>
  <header class="header shadow-sm">
    <div class="d-flex justify-content-between align-items-center">
      <div class="options d-flex align-items-center">
        <AuthBtnsComponent />
        <DarkModeBtn />
      </div>

      <div class="logo" style="height: 61px;">
        <router-link to="/" style="height: 100%;">
          <SiteLogo/>
        </router-link>
      </div>
    </div>
    <ProgressBarComponent />
  </header>
</template>
<script>


import DarkModeBtn from "./DarkModeBtn.vue";
import SiteLogo from "../Logo/SiteLogo.vue";
import AuthBtnsComponent from "./AuthBtnsComponent.vue";
import ProgressBarComponent from "../ProgressBar/ProgressBarComponent.vue";

export default {
  name: "HeaderComponent",
  components: {
    DarkModeBtn,
    SiteLogo,
    AuthBtnsComponent,
    ProgressBarComponent
  },
  data() {
    return {
      darkMode: false,
      active: false,
      showLogout: false,
      showNotifications: false,
      notifications: [],
      is_loading: true,
    };
  },
  methods: {
    toggleMenu() {
      this.active = !this.active;
    },
    openLogoutBox(e) {
      // this.showLogout = true;
      if (!e.target.classList.contains("logout-box")) {
        this.showLogout ? (this.showLogout = false) : (this.showLogout = true);
      }
    },
    closeLogoutBox() {
      this.showLogout = false;
    },
    
  },
  mounted() {
    // close logout box when click outside
    document.addEventListener("click", (e) => {
      // Close logout box when click outside the box or the icon
      if (
        e.target.classList.contains("logout-box") ||
        e.target.classList.contains("logout-box-item")
      ) {
        return;
      }
      if (
        e.target.classList.contains("user-image") ||
        e.target.classList.contains("user-image-icon")
      ) {
        // if logout box is open and click on the icon again close the box
        if (this.showLogout) {
          this.showLogout = true;
          return;
        }
        return;
      }
      this.showLogout = false;
    });
    // close notifications box when click outside
    document.addEventListener("click", (e) => {
      // Close notifications box when click outside the box or the icon
      if (
        e.target.classList.contains("notifications-box") ||
        e.target.classList.contains("notifications-box-item")
      ) {
        return;
      }
      if (
        e.target.classList.contains("bell") ||
        e.target.classList.contains("bell-icon")
      ) {
        // if logout box is open and click on the icon again close the box
        if (this.showNotifications) {
          this.showNotifications = true;
          return;
        }
        return;
      }
      this.showNotifications = false;
    });
  },
};
</script>
<style scoped>
.header {
  padding: 1rem 2rem;
  position: sticky;
  top: 0;
  width: 100%;
  background-color: #ffffff;
  z-index: 500;
}
body.dark .header {
  background-color: #00000080 !important;
}
@media(max-width:767px){
  .header{ 
    padding: 1rem 0.7rem;
  }
}
</style>
